import styled from 'styled-components';
import { AlertTriangle } from 'lucide-react';

export default function GuestBanner({ onSaveAccount }) {
  return (
    <Banner>
      <BannerContent>
        <AlertTriangle size={14} />
        <BannerText>Guest mode — your progress may be lost if you close this tab.</BannerText>
        <SaveButton onClick={onSaveAccount}>Save Account</SaveButton>
      </BannerContent>
    </Banner>
  );
}

const Banner = styled.div`
  background: rgba(245, 158, 11, 0.12);
  border-bottom: 1px solid rgba(245, 158, 11, 0.25);
  padding: 8px 16px;
  flex-shrink: 0;
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 600px;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.warning || '#b45309'};
  font-size: 13px;

  svg {
    flex-shrink: 0;
  }
`;

const BannerText = styled.span`
  flex: 1;
  line-height: 1.3;
`;

const SaveButton = styled.button`
  flex-shrink: 0;
  padding: 5px 12px;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.accent};
  color: white;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;
